export default __webpack_public_path__ + "static/media/01.c99d90a7.jpg";